import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HealthScanFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.38 20.1H6.62C4.86 20.1 3.86 19.1 3.86 17.34V6.58C3.86 4.82 4.86 3.82 6.62 3.82H17.38C19.14 3.82 20.14 4.82 20.14 6.58V17.34C20.14 19.1 19.14 20.1 17.38 20.1ZM12 15.3C14.2 13.74 15.68 12.34 15.68 11C15.68 10.02 14.98 9.04 13.76 9.04C13.1 9.04 12.32 9.38 12 10.32C11.68 9.38 10.9 9.04 10.24 9.04C9.02 9.04 8.32 10.02 8.32 11C8.32 12.34 9.8 13.74 12 15.3Z" />
    </SvgIcon>
  );
});
